import {
  MobileStockLocationSession,
  MobileStockLocationSessionStatus,
} from '../../../../../types/mobile_stock_location';
import { StockLocation } from '../../../../../types/stock_location';
import { Marker } from '../Marker';

export class StockLocationMarker extends Marker {
  constructor(public readonly stockLocation: StockLocation, public readonly session?: MobileStockLocationSession) {
    const coordinates = session?.coordinates || stockLocation.address?.coordinates;

    super(coordinates);
  }

  get id(): string {
    return this.stockLocation.id;
  }

  get properties() {
    let image;
    if (this.stockLocation.mobile) {
      if (this.session?.status === MobileStockLocationSessionStatus.active) {
        image = 'marker-truck-active';
      } else {
        image = 'marker-truck';
      }
    } else {
      image = 'marker-building';
    }

    return {
      ...super.properties,
      name: this.stockLocation.name,
      image: image,
    };
  }
}
